<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">{{ $t('add') }}</h2>
    <VariationForm @submit-requested="submitRequested"></VariationForm>
  </div>
</template>
 
<script>
import { mapActions } from 'vuex'
import VariationForm from './VariationForm.vue'

  export default {
  components: { VariationForm },
  methods: {
    ...mapActions('variations', ['postVariation']),
    submitRequested (input) {
      this.postVariation(input);
    },
  }
}
</script> 
 
<style scoped>
thead > tr > th
{
  text-align: unset !important;
}
</style> 